import api, { PodcastPromoCreditsResponse } from '@sparemin/api-sdk';
import { useCallback } from 'react';
import { useQuery, UseQueryOptions } from 'react-query';
import { useAuth } from 'state/auth';
import { podcastPromoQueryKeys } from './queryKeys';
import {
  creditsBalanceSelector,
  remainingMilliCentSelector,
  totalMilliCentSelector,
} from './selectors';

type QueryKey = ReturnType<typeof podcastPromoQueryKeys.myCredits>;

export interface UsePodcastPromoCreditsOptions<
  TData = PodcastPromoCreditsResponse,
> extends UseQueryOptions<
    PodcastPromoCreditsResponse,
    unknown,
    TData,
    QueryKey
  > {}

function usePodcastPromoCredits<TData = PodcastPromoCreditsResponse>(
  opts?: UsePodcastPromoCreditsOptions<TData>,
) {
  const { enabled = true } = opts ?? {};
  const { userId } = useAuth();

  return useQuery(
    podcastPromoQueryKeys.myCredits(),
    useCallback(() => api.getMyPodcastPromoCredits(), []),
    {
      ...opts,
      enabled: !!userId && enabled,
    },
  );
}

export const useRemainingMilliCent = () =>
  usePodcastPromoCredits({ select: remainingMilliCentSelector });

export const useTotalMilliCent = () =>
  usePodcastPromoCredits({ select: totalMilliCentSelector });

export const useCreditsBalance = () =>
  usePodcastPromoCredits({ select: creditsBalanceSelector });

export default usePodcastPromoCredits;
